{
  "title": "حوالة جديدة",
  "description": "اختر اتجاه الحوالة ثم أرسلها إلى العميل ليعبئ بياناته ويوقع.",
  "branch": "الفرع: {{branch}}",
  "fields": {
    "direction": "اتجاه الحوالة",
    "box": "الصندوق",
    "boxOption": "{{name}} - الرصيد {{balance}}",
    "bankAccount": "الحساب البنكي",
    "amount": "مبلغ الحوالة",
    "amountHint": "بالدينار الأردني، حتى خمس منازل عشرية",
    "reference": "مرجع التحويل",
    "senderIsReceiver": "المرسل هو المستلم",
    "notes": "ملاحظات",
    "target": "جهاز العميل",
    "commissionMode": "طريقة احتساب العمولة",
    "customerNotPresent": "العميل غير موجود",
    "customerNotPresentHint": "لن يرسل شيء إلى التابلت، وتحفظ العملية بدون بيانات العميل وتوقيعه"
  },
  "direction": {
    "BANK_TO_CASH": "من بنك إلى نقد",
    "BANK_TO_CASHHint": "يصل المبلغ إلى الحساب البنكي ويستلم العميل صافي النقد من الصندوق.",
    "CASH_TO_BANK": "من نقد إلى بنك",
    "CASH_TO_BANKHint": "يسلم العميل المبلغ نقدا ويحول المبلغ إلى حساب المستلم البنكي."
  },
  "commissionMode": {
    "DEDUCTED": "تخصم من المبلغ",
    "DEDUCTEDHint": "يسلم العميل المبلغ ويحول المبلغ بعد خصم العمولة منه.",
    "ADDED": "تضاف على المبلغ",
    "ADDEDHint": "يسلم العميل المبلغ مع العمولة ويحول المبلغ كاملا."
  },
  "validation": {
    "boxRequired": "اختر الصندوق",
    "bankAccountRequired": "اختر الحساب البنكي",
    "amountInvalid": "أدخل مبلغا صحيحا",
    "amountDecimals": "يسمح بخمس منازل عشرية كحد أقصى.",
    "amountPositive": "يجب أن يكون المبلغ أكبر من صفر",
    "targetRequired": "اختر جهاز التابلت أو هذا الجهاز"
  },
  "card": {
    "title": "تفاصيل الحوالة",
    "tier": "الشريحة",
    "noLimit": "بلا حد",
    "commission": "العمولة",
    "commissionMode": "طريقة احتساب العمولة",
    "amountCashToBank": "المبلغ المستلم من العميل",
    "net": "صافي النقد",
    "netCashToBank": "المبلغ المحول",
    "boxBalance": "رصيد الصندوق",
    "accountBalance": "رصيد الحساب البنكي",
    "enterAmount": "أدخل مبلغ الحوالة لعرض العمولة وصافي النقد",
    "noTier": "لا توجد شريحة لهذا المبلغ",
    "commissionNotBelow": "العمولة تساوي مبلغ الحوالة أو تزيد عليه",
    "insufficientBox": "رصيد الصندوق غير كافٍ",
    "insufficientAccount": "رصيد الحساب البنكي غير كافٍ",
    "calculating": "جاري الحساب..."
  },
  "duplicate": {
    "warning": "مرجع التحويل مستخدم في حوالة أخرى",
    "link": "الحوالة رقم {{number}}",
    "draftLink": "حوالة مبدئية",
    "note": "يمكنك المتابعة، وسيحفظ التنبيه مع الحوالة."
  },
  "target": {
    "thisDevice": "هذا الجهاز",
    "online": "متصل",
    "offline": "غير متصل",
    "noTablets": "لا توجد أجهزة تابلت في هذا الفرع",
    "busy": "مشغول",
    "notConfigured": "خدمة التابلت غير مربوطة بهذا النظام",
    "unavailable": "تعذر الوصول إلى خدمة التابلت"
  },
  "actions": {
    "send": "إرسال إلى التابلت",
    "sending": "جاري الإرسال...",
    "resend": "إعادة الإرسال إلى التابلت",
    "discard": "إلغاء الطلب",
    "post": "اعتماد الحوالة",
    "newTransfer": "حوالة جديدة",
    "printReceipt": "طباعة الإيصال",
    "viewDetails": "عرض التفاصيل",
    "editParties": "تعديل بيانات الأطراف",
    "saveDraft": "حفظ كمبدئية"
  },
  "capture": {
    "title": "بيانات العميل",
    "notSent": "لم يرسل الطلب إلى جهاز العميل بعد",
    "waitingTablet": "بانتظار تعبئة البيانات على {{tablet}}",
    "waitingThisDevice": "بانتظار تعبئة البيانات على هذا الجهاز",
    "tabletOffline": "جهاز التابلت غير متصل",
    "tabletOnline": "جهاز التابلت متصل",
    "submittedAt": "أكمل العميل البيانات في {{time}}",
    "signatureVoid": "تغيرت البيانات بعد التوقيع. يلزم إرسالها إلى العميل من جديد.",
    "cancelled": "ألغي هذا الطلب على جهاز العميل",
    "expired": "انتهت مدة الطلب قبل أن يكمل العميل البيانات. أعد الإرسال إلى العميل.",
    "failed": {
      "SIGNATURE_INVALID": "تعذر حفظ التوقيع. لم يحفظ شيء، أعد الإرسال إلى العميل.",
      "DATA_INVALID": "بيانات العميل غير مكتملة أو غير صالحة. لم يحفظ شيء، أعد الإرسال إلى العميل.",
      "NOT_COLLECTED": "تعذر استلام بيانات العميل من خدمة التابلت. أعد الإرسال إلى العميل."
    }
  },
  "review": {
    "receiver": "المستلم",
    "receiverSelf": "المرسل والمستلم",
    "sender": "المرسل",
    "fullName": "الاسم الكامل",
    "phone": "الهاتف",
    "document": "الوثيقة",
    "documentTypes": {
      "NATIONAL_ID": "هوية وطنية",
      "PASSPORT": "جواز سفر"
    },
    "documentNumber": "رقم الوثيقة",
    "documentCountry": "دولة الإصدار",
    "language": "لغة العميل",
    "languages": {
      "ar": "العربية",
      "en": "English"
    },
    "signature": "التوقيع",
    "signatureLoading": "جاري تحميل التوقيع",
    "signatureFailed": "تعذر تحميل التوقيع",
    "customers": "في نظام العملاء",
    "matchFound": "{{name}} - المستوى {{level}}",
    "matchFoundNoName": "مسجل دون اسم - المستوى {{level}}",
    "matchNotFound": "غير مسجل",
    "matchUnavailable": "تعذر الوصول إلى نظام العملاء"
  },
  "blockers": {
    "title": "لا يمكن اعتماد الحوالة بعد",
    "NO_TIER": "لا توجد شريحة لهذا المبلغ",
    "COMMISSION_NOT_BELOW_AMOUNT": "العمولة تساوي مبلغ الحوالة أو تزيد عليه",
    "INSUFFICIENT_BOX_BALANCE": "رصيد الصندوق غير كافٍ",
    "INSUFFICIENT_BANK_BALANCE": "رصيد الحساب البنكي غير كافٍ",
    "BOX_INACTIVE": "الصندوق غير فعال",
    "BANK_ACCOUNT_INACTIVE": "الحساب البنكي غير فعال",
    "CAPTURE_MISSING": "بانتظار بيانات العميل وتوقيعه",
    "SIGNATURE_VOID": "تغيرت البيانات بعد التوقيع",
    "unsaved": "تغيرت بيانات الحوالة. أرسلها إلى العميل من جديد."
  },
  "post": {
    "title": "اعتماد الحوالة",
    "effect": "استلام {{amount}} في حساب {{account}} ودفع {{net}} نقدا من {{box}}، العمولة {{commission}}، المستلم {{receiver}}",
    "effectCashToBank": "استلام {{amount}} في {{box}} وتحويل {{net}} من حساب {{account}}، العمولة {{commission}} ({{mode}})، المرسل {{sender}}، المستلم {{receiver}}",
    "checkBank": "تأكد من وصول المبلغ إلى الحساب البنكي وعد النقد قبل التأكيد.",
    "checkCash": "عد النقد وتأكد من تحويل المبلغ إلى حساب المستلم قبل التأكيد.",
    "confirm": "تأكيد",
    "posting": "جاري الاعتماد..."
  },
  "result": {
    "title": "تم اعتماد الحوالة",
    "number": "رقم الحوالة",
    "net": "صافي النقد المسلّم",
    "amountCashToBank": "المبلغ المستلم من العميل",
    "netCashToBank": "المبلغ المحول",
    "message": "رسالة واتساب",
    "messageNone": "لا توجد رسالة",
    "sync": "نظام العملاء",
    "syncPending": "بانتظار المزامنة",
    "syncDone": "تمت المزامنة",
    "messageStatus": {
      "PENDING": "بانتظار الإرسال",
      "SENT": "تم الإرسال",
      "DELIVERED": "تم التسليم",
      "FAILED": "فشل الإرسال"
    }
  },
  "discard": {
    "title": "إلغاء الطلب؟",
    "description": "تصبح الحوالة المبدئية ملغاة دون أي أثر على الأرصدة.",
    "keep": "متابعة الحوالة",
    "done": "تم إلغاء الطلب"
  },
  "parties": {
    "title": "تعديل بيانات الأطراف",
    "description": "أي تعديل يلغي التوقيع ويلزم إرسال النموذج إلى العميل من جديد.",
    "saved": "تم تحديث بيانات الأطراف",
    "invalidValue": "القيمة غير صالحة"
  },
  "toasts": {
    "sent": "تم الإرسال إلى جهاز العميل",
    "resent": "تمت إعادة الإرسال",
    "saved": "تم الحفظ"
  },
  "notDraft": {
    "title": "لم تعد هذه الحوالة مبدئية",
    "body": "اعتمدت أو ألغيت من قبل موظف آخر. افتح تفاصيلها للاطلاع على حالتها.",
    "open": "عرض التفاصيل"
  }
}
